import React from 'react'
import { Field } from 'redux-form'
import { FormGroup, ControlLabel, HelpBlock } from 'react-bootstrap'
import PropTypes from 'prop-types'

import './fieldGroup.scss'
import CheckboxComponent from '../CheckboxComponent/CheckboxComponent'
import InputComponent from './FieldComponents/InputComponent'
import SelectComponent from './FieldComponents/SelectComponent'
import DatePickerComponent from '../DatePickerComponent/DatePickerComponent'
import CaptchaComponent from '../../core/CaptchaComponent/CaptchaComponent'

class FieldGroupComponent extends React.Component {
    renderInputWrapper = (
        label,
        required,
        touched,
        invalid,
        error,
        inputField,
    ) => {
        const isInvalid = (touched && invalid) || (error && error[0].message);
        const className = (isInvalid && !error) || (isInvalid && !error[0].message) || (error && !(!error[0].value && !error[1].value && !error[2].value && !error[3].value)) ? 'invalid' : '';
        var errMessage;
        if (error && error[0].message) {
            errMessage = <span>
                {error.map((err, i) => {
                    return <span key={err.message} className={err.value ? 'gray' : 'green'} style={{color: 'black'}}>{err.message}{i < error.length - 1 && <br />}</span>
                })}
            </span>;
        } else {
            errMessage = error;
        }
        return <span>
            {label && <ControlLabel className={className}>
                {required && <span className="required">* </span>}{label}
            </ControlLabel>}
            {inputField(className)}
            {isInvalid && error && <HelpBlock>{errMessage}</HelpBlock>}
        </span>
    }

    renderTextInput = ({
        input,
        label,
        required,
        disabled,
        type,
        meta: { touched, invalid, error },
        ...formProps
    }) => this.renderInputWrapper(
        label,
        required,
        touched,
        invalid,
        error,
        (className) => {
            let component

            switch (type) {
                case 'select': {
                    component = <SelectComponent
                        input={input}
                        formProps={formProps}
                        label={label}
                        className={className}
                    />
                    break
                }
                case 'checkbox': {
                    component = <CheckboxComponent
                        {...input}
                        {...formProps}
                        label={label}
                    />
                    break
                }
                case 'date': {
                    component = <DatePickerComponent
                        selected={input.value}
                        formProps={{
                            ...formProps,
                            onChange: input.onChange,
                        }}
                    />
                    break
                }
                case 'captcha': {
                    component = <CaptchaComponent
                        input={input}
                        formProps={formProps}
                    />
                    break
                }
                case 'search': {
                    component = <InputComponent
                        input={input}
                        formProps={{
                            ...formProps,
                            onChange: input.onChange,
                        }}
                    />
                    break
                }
                default: {
                    component = <InputComponent
                        input={input}
                        type={type}
                        formProps={formProps}
                        readOnly={disabled}
                        className={className}
                        value={this.props.value}
                    />
                    break
                }
            }

            return component
        }
    )

    render() {
        const { label, name, className, disabled, type, required, placeholder, formProps, onChange } = this.props
        return (
            <FormGroup className={className}>
                <Field
                    {...formProps}
                    name={name}
                    type={type}
                    label={label}
                    component={this.renderTextInput}
                    disabled={disabled}
                    required={required}
                    placeholder={placeholder}
                    onChange={onChange}
                />
            </FormGroup>
        )
    }
}

FieldGroupComponent.defaultProps = {
    type: 'text',
    className: '',
    disabled: false,
    required: true,
    placeholder: '',
    formProps: {},
}

FieldGroupComponent.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    required: PropTypes.bool.isRequired,
    placeholder: PropTypes.string.isRequired,
    formProps: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    value: PropTypes.string,
}

export default FieldGroupComponent



// WEBPACK FOOTER //
// ./src/components/core/FieldGroupComponent/FieldGroupComponent.js